export enum EActionTypes {
  GET_SPECIALISTS_REQUEST = 'specialists/request',
  GET_SPECIALISTS_SUCCESS = 'specialists/success',
  GET_SPECIALISTS_FAILURE = 'specialists/failure',
}
